import { FC, PropsWithChildren } from "react";
import styled from "styled-components";

const StyledNudgeBlurrer =
  styled.div((props) => props?.theme?.themeConfig?.nudge?.blurrer?.styles);

export const NudgeBlurrer: FC<PropsWithChildren> = ({ children }) => (
  <StyledNudgeBlurrer className="voa_border_blurrer">
    {children}
  </StyledNudgeBlurrer>
)
